import { chakra } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

/**
 * "Skip to main content" link (WCAG 2.4.1 — Bypass Blocks). Kept in the DOM and
 * tab order as the first focusable element, but visually moved off-screen until
 * it receives keyboard focus, at which point it slides into the top-left corner.
 *
 * Targets the `#main` landmark rendered by `Layout` / `AdminLayout`, which is
 * given `tabIndex={-1}` so activating the link moves focus into the main region.
 */
export const SkipLink = () => {
  const { t } = useTranslation()

  return (
    <chakra.a
      href="#main"
      position="fixed"
      top="3"
      left="3"
      // Above the fixed HeadBar (zIndex 1000) so it is never clipped on focus.
      zIndex="2147483647"
      px="4"
      py="2"
      bg="bg"
      color="fg"
      rounded="md"
      borderWidth="1px"
      borderColor="border"
      fontWeight="medium"
      boxShadow="md"
      // Hidden off-screen by default; revealed only for keyboard users on focus.
      transform="translateY(-150%)"
      transition="transform 0.15s ease-in-out"
      _focusVisible={{
        transform: 'translateY(0)',
        outline: '2px solid',
        outlineColor: 'colorPalette.focusRing',
        outlineOffset: '2px',
      }}
    >
      {t('layout.skipToContent')}
    </chakra.a>
  )
}
